import { ADMIN_PANEL_CLIENT_ID } from 'constants/auth';

export class MilestoneDefinitionsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getPresentationSettings() {
    // DEV-3647: this loan-pipeline shell call 403s for TPO broker users who lack loan access. Opt out of the
    // global forbidden-status interceptor so it never reloads the whole page for them.
    return this.#http.get('api/milestoneDefinitionCollection/presentationSettings', {
      params: {
        forClient: ADMIN_PANEL_CLIENT_ID,
        includeDeleted: true,
      },
      skipResponseInterceptor: { forbiddenError: true },
    });
  }

  async getExternalCrmMilestones() {
    return this.#http.get('api/milestoneDefinitionCollection/externalCrmMilestones');
  }

  async getMilestoneDefinitions() {
    return this.#http.get('api/milestoneDefinitionCollection');
  }

  async modifyMilestoneDefinitionCollection(body) {
    return this.#http.put('api/milestoneDefinitionCollection', body);
  }

  async reorderMilestoneDefinitions(orderedIds) {
    return this.#http.put('api/milestoneDefinitionCollection/reorder', orderedIds);
  }
}
